import React, { Component } from "react";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import constant from "../../constant";
import OtpInput from "react-otp-input";
import touchIMG from "../../assets/images/touch.png";
export default class Otp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: {},
      seconds: 30,
      otp: "",
    };
    this.timer = 0;
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
  }

  verifyOTP = () => {
    this.props.verifyOTP(this.state.otp);
  };

  reSendOTP = () => {
    this.props.reSendOTP();
  };

  handleChange = (otp) => {
    this.setState({ otp });
  };

  secondsToTime(secs) {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    let obj = {
      h: hours,
      m: minutes,
      s: seconds,
    };
    return obj;
  }

  componentDidMount() {
    const start = this.startTimer();
    let timeLeftVar = this.secondsToTime(this.state.seconds);
    this.setState({ time: timeLeftVar });
  }

  startTimer() {
    if (this.timer == 0 && this.state.seconds > 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  }
  countDown() {
    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });

    // Check if we're at zero.
    if (seconds == 0) {
      clearInterval(this.timer);
    }
  }

  render() {
    return (
      <React.Fragment>
         <button type="button"  style={{marginTop:"-67px"}}  onClick={()=> this.props.onCancel()} class="close" data-dismiss="modal" aria-label="Close">
             <span aria-hidden="true">&times;</span>
           </button>
        <form>
          <div className="row">
            <div className="col-12 text-center">
              <div className="otpimg pb-2">
                <img style={{width:"210px"}} src={touchIMG} />
              </div>
              <h5>Verification</h5>
              <p>
                You will get a OTP via Mobile No.
                {this?.props?.mobile &&
                  (this?.props?.mobile?.slice(0, 5) +
                    "******" +
                    this?.props?.mobile?.slice(11, 13))}
              </p>
              <p className="text-danger pt-2">{this.props.resendOtpMessage}</p>
            </div>
            <div class="col-12 justify-content-center">
              <OtpInput
                value={this.state.otp}
                onChange={this.handleChange}
                numInputs={6}
                isInputNum={true}
                className="textCenter otp-mobile"
                separator={<span style={{ visibility: "hidden" }}>-</span>}
                inputStyle={{ width: "55px",height: "48px", padding: "3px", background:"#efefef",border: "1px solid #d2d2d2" }}
                containerStyle={{ justifyContent: "center" }}
              />
            </div>
          </div>

          <div className="row">
            <div class="col-12 text-center pb-3 pt-3">
              <button
                type="button"
                className="btn-verify btn btn-danger mr-2"
                onClick={this.verifyOTP}
              >
                VERIFY
              </button>
            </div>
            {this.props.showTimer && (
              <div className="col-12 text-center">
                Resend in {this.state.time.s} Second
              </div>
            )}

            {this.state.time.s == 0 && (
              <div className="col-12 text-center">
                {" "}
                <p>
                  Didn't receive the verification OTP?{" "}
                  <span
                    style={{
                      color: "#e81c28",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => this.reSendOTP()}
                  >
                    Resend again
                  </span>
                </p>{" "}
              </div>
            )}
          </div>
        </form>
      </React.Fragment>
    );
  }
}
